import { render } from "./BackerCenterPledgeCardAdditionalInfo.vue?vue&type=template&id=5ac38688"
import script from "./BackerCenterPledgeCardAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgeCardAdditionalInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__